import { Component, Input } from '@angular/core';
import { ModalService } from '../../services/modal.service';
@Component({
  selector: 'modalChildRatio',
  templateUrl: './modal-child-ratios.component.html',
})
export class ModalChildRatiosComponent {
  constructor(public modalService: ModalService) {}
}
